export default __webpack_public_path__ + "static/media/joys500_wiring.0114d38c.jpg";